import { format, isThisYear, isToday, isYesterday } from '../dates';

export const getRelativeDateText = (date?: Date) => {
  if (!date) {
    return 'Unknown';
  }

  if (isYesterday(date)) {
    return 'Yesterday';
  }

  if (isToday(date)) {
    return 'Today';
  }

  if (isThisYear(date)) {
    return format(date, 'dd MMM');
  }

  return format(date, 'dd MMM yyyy');
};
